"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Portfolio() {
  const artifacts = [{
    id: 1,
    title: "Industrial Automation",
    spec: "Precision / PLC Integration",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_automation.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_automation.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/industrial_automation.png-wvc-sizes",
      alt: "Industrial automation control panel installation"
    },
    gridClasses: "lg:col-start-1 lg:col-end-5 lg:row-start-1 lg:row-end-3",
    aspectClasses: "aspect-[3/4]"
  }, {
    id: 2,
    title: "System Integration",
    spec: "Custom / High-Efficiency",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/system_integration.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/system_integration.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/system_integration.png-wvc-sizes",
      alt: "System integration of industrial machinery"
    },
    gridClasses: "lg:col-start-5 lg:col-end-9 lg:row-start-1 lg:row-end-2 lg:mt-20",
    aspectClasses: "aspect-[4/3]"
  }, {
    id: 3,
    title: "Facility Upgrades",
    spec: "Safety / Compliance-Grade",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/facility_upgrades.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/facility_upgrades.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/facility_upgrades.png-wvc-sizes",
      alt: "Facility upgrades in industrial plant"
    },
    gridClasses: "lg:col-start-9 lg:col-end-13 lg:row-start-2 lg:row-end-3",
    aspectClasses: "aspect-square"
  }, {
    id: 4,
    title: "Power Distribution",
    spec: "Reliable / High-Capacity",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/power_distribution.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/power_distribution.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/power_distribution.png-wvc-sizes",
      alt: "Power distribution infrastructure setup"
    },
    gridClasses: "lg:col-start-2 lg:col-end-6 lg:row-start-3 lg:row-end-4 lg:mt-16",
    aspectClasses: "aspect-[4/3]"
  }, {
    id: 5,
    title: "Process Control",
    spec: "Advanced / Monitoring",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/process_control.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/process_control.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/process_control.png-wvc-sizes",
      alt: "Process control monitoring station"
    },
    gridClasses: "lg:col-start-6 lg:col-end-10 lg:row-start-3 lg:row-end-5",
    aspectClasses: "aspect-[3/4]"
  }, {
    id: 6,
    title: "Safety Systems",
    spec: "Certified / Industrial",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/safety_systems.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/safety_systems.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650264/img/safety_systems.png-wvc-sizes",
      alt: "Industrial safety systems implementation"
    },
    gridClasses: "lg:col-start-10 lg:col-end-13 lg:row-start-4 lg:row-end-5",
    aspectClasses: "aspect-square"
  }];
  return;
}